import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
    Typography,
    Box,
    TablePagination,
    TableFooter
} from "@mui/material";
import Select from "react-select";
import Loader from "utils/Loader";
import ZoomWrapper from "utils/ZoomWrapper";
import { components } from "react-select";
import CurrentMonthsSalesReportController from
    "pages/Controller/CurrentMonthsSalesReportController";

/* ================= SELECT ALL ================= */
const addSelectAllOption = (options) => [
    { label: "Select All", value: "__ALL__", isSelectAll: true },
    ...options
];

const NoMultiValue = () => null;

/* ================= CHECKBOX OPTION ================= */
const CheckboxOption = (props) => {
    const { label, amount, isSelectAll } = props.data;
    const { isSelected, selectOption, getValue } = props;

    // 🔥 FORCE Select-All checked state
    const allSelected =
        isSelectAll &&
        getValue().length > 0 &&
        getValue().length === props.options.filter(o => !o.isSelectAll).length;

    const checked = isSelectAll ? allSelected : isSelected;

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <button
            type="button"
            onMouseDown={handleClick}
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 10px",
                cursor: "pointer",
                background: isSelectAll ? "#f5f5f5" : "#fff",
                color: "#000",
                border: "none",
                width: "100%",
                textAlign: "left",
                fontSize: "13px"
            }}
        >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                    type="checkbox"
                    checked={checked}
                    readOnly
                    style={{ width: 14, height: 14 }}
                />
                <span style={{ color: "#000", fontWeight: 400 }}>{label}</span>
            </div>

        </button>
    );
};
/* ================= SELECT STYLE ================= */
const singleLineSelectStyles = {
    menuPortal: (b) => ({ ...b, zIndex: 9999 }),
    control: (base) => ({
        ...base,
        minHeight: 38,
        height: 38
    }),
    valueContainer: (base) => ({
        ...base,
        height: 38,
        padding: "0 8px",
        overflow: "hidden"
    }),
    placeholder: (base) => ({
        ...base,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        color: "#000",
        fontWeight: 500
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: 38
    }),
};


const CurrentMonthsSalesReport = () => {
    const {
        salesRows,
        topCustomers,
        topQualities,
        cloading,
        page,
        totalRecords,
        handleChangePage,
        qualityPage,
        qualityPagination,
        handleQualityPageChange,
        customerPage,
        customerPagination,
        handleCustomerPageChange,
        filters,
        handleFilterChange,
        zoneOptions,
        subdivisionOptions,
        customerNameOptions,
        lastUpdatedDate,
        month,
        divisionlist,
        isFromApp
    } = CurrentMonthsSalesReportController();


    const [isZoneOpen, setIsZoneOpen] = useState(false);
    const [isCustomerOpen, setIsCustomerOpen] = useState(false);
    const [isSubdivisionOpen, setIsSubdivisionOpen] = useState(false);

    const [subdivisionSearchText, setSubdivisionSearchText] = useState("");
    const [customerSearchText, setCustomerSearchText] = useState("");
const formatQty = (num) => {
    return Number(num || 0).toLocaleString("en-IN");
};
    const makeClearTextOnlyIndicator = (setText) =>
        function ClearTextOnlyIndicator(props) {
            return (
                <components.ClearIndicator
                    {...props}
                    innerProps={{
                        ...props.innerProps,
                        onMouseDown: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setText("");       // ✅ clear only typed text
                        }
                    }}
                />
            );
        };

    const SubdivisionClearIndicator = makeClearTextOnlyIndicator(setSubdivisionSearchText);
    const CustomerClearIndicator = makeClearTextOnlyIndicator(setCustomerSearchText);


    /* ================= PLACEHOLDER LOGIC (SAME AS PENDING) ================= */

    // ZONE
    // const excludedZones = zoneOptions.filter(
    //     (z) => !filters.zone.some((s) => s.value === z.value)
    // );

    //const selectedZoneCount = filters.zone.length;

    // const zonePlaceholder = isZoneOpen
    //     ? `ZONE${selectedZoneCount ? ` selected (${selectedZoneCount})` : ""}`
    //     : excludedZones.length
    //         ? `ZONE: Excluded: ${excludedZones
    //             .map(z => z.label)
    //             .join(", ")
    //             .slice(0, 45)}${excludedZones
    //                 .map(z => z.label)
    //                 .join(", ").length > 45 ? "..." : ""}`
    //         : "ZONE";

    // const zoneTooltip =
    //     excludedZones.length
    //         ? `Excluded:\n${excludedZones.map(z => z.label).join("\n")}`
    //         : "";

    // CUSTOMER
    const excludedCustomers = customerNameOptions.filter(
        (c) => !filters.customerName.some((s) => s.value === c.value)
    );

    const selectedCustomerCount = filters.customerName.length;

    const customerPlaceholder = isCustomerOpen
        ? `NAME${selectedCustomerCount ? ` selected (${selectedCustomerCount})` : ""}`
        : excludedCustomers.length
            ? `NAME: Excluded: ${excludedCustomers
                .map(c => c.label)
                .join(", ")
                .slice(0, 45)}${excludedCustomers
                    .map(c => c.label)
                    .join(", ").length > 45 ? "..." : ""}`
            : "NAME";

    const customerTooltip =
        excludedCustomers.length
            ? `Excluded:\n${excludedCustomers.map(c => c.label).join("\n")}`
            : "";

    // SUBDIVISION
    const excludedSubdivisions = subdivisionOptions.filter(
        (s) => !filters.subdivision.some((f) => f.value === s.value)
    );

    const selectedSubdivisionCount = filters.subdivision.length;

    const subdivisionPlaceholder = isSubdivisionOpen
        ? `SUBDIVISION${selectedSubdivisionCount ? ` selected (${selectedSubdivisionCount})` : ""}`
        : excludedSubdivisions.length
            ? `SUBDIVISION: Excluded: ${excludedSubdivisions
                .map(s => s.label)
                .join(", ")
                .slice(0, 45)}${excludedSubdivisions
                    .map(s => s.label)
                    .join(", ").length > 45 ? "..." : ""}`
            : "SUBDIVISION";

    const subdivisionTooltip =
        excludedSubdivisions.length
            ? `Excluded:\n${excludedSubdivisions.map(s => s.label).join("\n")}`
            : "";

    /* ================= SELECT ALL HANDLERS ================= */

    // ZONE
    // const handleZoneChange = (selected) => {
    //     if (!selected) {
    //         handleFilterChange("zone")([]);
    //         return;
    //     }

    //     if (selected.some(o => o.value === "__ALL__")) {
    //         const allSelected =
    //             filters.zone.length === zoneOptions.length;

    //         handleFilterChange("zone")(
    //             allSelected ? [] : zoneOptions
    //         );
    //         return;
    //     }

    //     handleFilterChange("zone")(selected);
    // };

    // SUBDIVISION
    const handleSubdivisionChange = (selected) => {
        if (!selected) {
            handleFilterChange("subdivision")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.subdivision.length === subdivisionOptions.length;

            handleFilterChange("subdivision")(
                allSelected ? [] : subdivisionOptions
            );
            return;
        }

        handleFilterChange("subdivision")(selected);
    };

    // CUSTOMER
    const handleCustomerChange = (selected) => {
        if (!selected) {
            handleFilterChange("customerName")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.customerName.length === customerNameOptions.length;

            handleFilterChange("customerName")(
                allSelected ? [] : customerNameOptions
            );
            return;
        }

        handleFilterChange("customerName")(selected);
    };

    /* ================= GRAND TOTALS ================= */

    // Quality Wise Totals
    const qualityTotals = topQualities.reduce(
        (acc, r) => {
            acc.qty += Number(r.total_qty || 0);
            acc.amt += Number(r.total_amount || 0);
            return acc;
        },
        { qty: 0, amt: 0 }
    );

    // Customer Wise Totals
    const customerTotals = topCustomers.reduce(
        (acc, r) => {
            acc.qty += Number(r.total_mtr || 0);
            acc.amt += Number(r.total_amount || 0);
            return acc;
        },
        { qty: 0, amt: 0 }
    );

    const parseNum = (val) => {
        const n = Number(String(val ?? "").replace(/,/g, ""));
        return Number.isNaN(n) ? 0 : n;
    };

    const formatIndianShortt = (num) => {
       const n = Number(num || 0);
        const sign = n < 0 ? "-" : "";
        const abs = Math.abs(n);

        if (abs >= 10000000) return `${sign}${(abs / 10000000).toFixed(2)} Cr`;
        if (abs >= 100000) return `${sign}${(abs / 100000).toFixed(2)} L`;
        if (abs >= 1000) return `${sign}${(abs / 1000).toFixed(2)} K`;
        return `${sign}${abs}`;
    };

    const formatIndianShort = (num) => {
    const n = Number(num || 0);
    const sign = n < 0 ? "-" : "";
    const abs = Math.abs(n);

    return `${sign}${(abs / 100000).toFixed(2)} L`;
};

    const mainTotals = salesRows.reduce(
        (acc, r) => {
            acc.qty += Number(r.qty);
            acc.amt += Number(r.netAmount);
            return acc;
        },
        { qty: 0, amt: 0 }
    );


    return (
        <>
            {cloading && (
                <div className="overlay">
                    <Loader />
                    <span style={{ marginLeft: 10 }}>Data loading...</span>
                </div>
            )}

            <ZoomWrapper>
                <div className= {isFromApp ? "" : "bg" } style={{ display: "block", zoom: "90%" }}>

                    {/* ================= PAGE TITLE ================= */}
                   
                    {!isFromApp && (
  <div style={{ textAlign: "center" }}>
    <span className="font20">Current Month Sales Report</span>
  </div>
)}

{!isFromApp && ( <div className="orderrow"></div> )}

                    {/* ================= INFO HEADER ================= */}
                    <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                        <Typography align="center" color="#444">
                            DIVISION WISE CURRENT MONTH SALES DASHBOARD{" "}
                            {divisionlist
                                ? divisionlist
                                    .split(",")
                                    .map(d => d.trim().toUpperCase())
                                    .join(", ")
                                : "--"}
                            &nbsp;
                            {/* CURRENT MONTH - {month ? month.toUpperCase() : "--"}&nbsp; */}
                            UPDATED AS ON : {lastUpdatedDate || "--"} &nbsp;
                        </Typography>
                    </Paper>

                    {/* ================= FILTERS ================= */}
                    <Grid container spacing={2} sx={{ mb: 3, justifyContent: "center" }}>

                        <Grid item xs={12} md={3}>
                            <div title={customerTooltip}>
                               
                                {/* <Select
                                    options={addSelectAllOption(customerNameOptions)}
                                    value={filters.customerName}
                                    onChange={handleCustomerChange}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}
                                    components={{ Option: CheckboxOption, MultiValue: NoMultiValue }}
                                    placeholder={customerPlaceholder}
                                    onMenuOpen={() => setIsCustomerOpen(true)}
                                    onMenuClose={() => setIsCustomerOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                /> */}
                                <Select
                                    options={addSelectAllOption(customerNameOptions)}
                                    value={filters.customerName}
                                    onChange={handleCustomerChange}

                                    inputValue={customerSearchText}
                                    onInputChange={(val, { action }) => {
                                        if (action === "input-change") {
                                            setCustomerSearchText(val);
                                        }
                                        if (action === "set-value") {
                                            return customerSearchText;
                                        }
                                        return val;
                                    }}

                                    isMulti
                                    isClearable={Boolean(customerSearchText)}   // ✅ cross icon logic
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}

                                    components={{
                                        Option: CheckboxOption,
                                        MultiValue: NoMultiValue,
                                        ClearIndicator: CustomerClearIndicator    // ✅ custom clear
                                    }}

                                    placeholder={customerPlaceholder}
                                    onMenuOpen={() => setIsCustomerOpen(true)}
                                    onMenuClose={() => setIsCustomerOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                />

                            </div>
                                {/* <Select
                                    options={addSelectAllOption(zoneOptions)}
                                    value={filters.zone}
                                    onChange={handleZoneChange}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}
                                    components={{ Option: CheckboxOption, MultiValue: NoMultiValue }}
                                    placeholder={zonePlaceholder}
                                    onMenuOpen={() => setIsZoneOpen(true)}
                                    onMenuClose={() => setIsZoneOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                /> */}
                                {/* <Select
                                    options={zoneOptions}
                                    value={filters.zone[0] || null}     // ✅ pick first if exists
                                    onChange={(val) => handleFilterChange("zone")(val ? [val] : [])}
                                    isMulti={false}
                                    isClearable={true}
                                    placeholder="ZONE"
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                /> */}
                        </Grid>

                        {/* <Grid item xs={0} md={3}>
                            <div title={subdivisionTooltip}> */}
                                {/* <Select
                                    options={addSelectAllOption(subdivisionOptions)}
                                    value={filters.subdivision}
                                    onChange={handleSubdivisionChange}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}
                                    components={{ Option: CheckboxOption, MultiValue: NoMultiValue }}
                                    placeholder={subdivisionPlaceholder}
                                    onMenuOpen={() => setIsSubdivisionOpen(true)}
                                    onMenuClose={() => setIsSubdivisionOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                /> */}
                                {/* <Select
                                    options={addSelectAllOption(subdivisionOptions)}
                                    value={filters.subdivision}
                                    onChange={handleSubdivisionChange}

                                    inputValue={subdivisionSearchText}
                                    onInputChange={(val, { action }) => {
                                        if (action === "input-change") {
                                            setSubdivisionSearchText(val);
                                        }
                                        if (action === "set-value") {
                                            return subdivisionSearchText;   // keep typed text
                                        }
                                        return val;
                                    }}

                                    isMulti
                                    isClearable={Boolean(subdivisionSearchText)}   // ✅ show cross only when typing
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}

                                    components={{
                                        Option: CheckboxOption,
                                        MultiValue: NoMultiValue,
                                        ClearIndicator: SubdivisionClearIndicator   // ✅ custom clear
                                    }}

                                    placeholder={subdivisionPlaceholder}
                                    onMenuOpen={() => setIsSubdivisionOpen(true)}
                                    onMenuClose={() => setIsSubdivisionOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                /> */}
{/* 
                            </div>
                        </Grid> */}


                    </Grid>

                    {/* ================= SUMMARY TABLES ================= */}
                    <Grid container spacing={2} sx={{ mb: 3, justifyContent: "center" }}>

                        {/* QUALITY WISE */}
                        {/* <Grid item xs={12} md={5}>
                            <Paper elevation={3}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ background: "red" }}>
                                            <TableCell colSpan={3} align="center" sx={{ color: "#fff" }}>
                                                List of quality wise sales mtr & sales amt
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="center"><b>ZONE</b></TableCell>
                                            <TableCell align="center"><b>QTY</b></TableCell>
                                            <TableCell align="center"><b>AMT</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {topQualities.map((r, i) => (
                                            <TableRow key={i}>
                                                <TableCell align="center">{r.zone}</TableCell>
                                                <TableCell align="center">{r.total_qty}</TableCell>
                                                <TableCell align="center">{r.total_amount}</TableCell>
                                            </TableRow>
                                        ))}

                                        <TableRow sx={{ background: "#f3f3f3" }}>
                                            <TableCell align="center" sx={{ fontWeight: 700 }}>
                                                GRAND TOTAL
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontWeight: 700 }}>
                                                {qualityTotals.qty.toLocaleString("en-IN")}
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontWeight: 700 }}>
                                                {qualityTotals.amt.toLocaleString("en-IN")}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                    <TableFooter>
                                            <TableRow>
                                                <TableCell colSpan={3} sx={{ p: 0 }}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",   // ✅ move to right
                                                            alignItems: "center",
                                                            pr: 2
                                                        }}
                                                    >
                                                        <TablePagination
                                                            component="div"
                                                            rowsPerPageOptions={[qualityPagination.limit]}
                                                            count={qualityPagination.totalRecords || 0}
                                                            rowsPerPage={qualityPagination.limit || 10}
                                                            page={(qualityPage || 1) - 1}
                                                            onPageChange={handleQualityPageChange}
                                                        />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                    </TableFooter>

                                </Table>
                            </Paper>
                        </Grid> */}

                        {/* CUSTOMER WISE */}
                        <Grid item xs={12} md={4}>
                            <Typography
                                sx={{
                                    mb: 1,
                                    px: 0,
                                    fontSize: { xs: "0.95rem", md: "1rem" },
                                    fontWeight: 700,
                                    color: "#ffffff"
                                }}
                            >
                                List of Customer wise sales mtr & sales amt
                            </Typography>
                            <Paper elevation={3} sx={{ overflow: "hidden" }}>
                                <TableContainer
                                    sx={{
                                        overflowY: "visible",
                                        overflowX: "auto"
                                    }}
                                >
                                <Table size="small" stickyHeader sx={{ minWidth: 520 }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left" sx={{ background: "red", color: "#fff", fontWeight: 700 }}>NAME</TableCell>
                                            <TableCell align="left" sx={{ background: "red", color: "#fff", fontWeight: 700 }}>ZONE</TableCell>
                                            <TableCell align="center" sx={{ background: "red", color: "#fff", fontWeight: 700 }}>QTY (mtr)</TableCell>
                                            <TableCell align="center" sx={{ background: "red", color: "#fff", fontWeight: 700 }}>AMT</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {topCustomers.map((r, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{
                                                    backgroundColor: i % 2 === 0 ? "#fafafa" : "#ffffff",
                                                    "&:hover": { backgroundColor: "#fff3f3" }
                                                }}
                                            >
                                                <TableCell align="left" sx={{ fontSize: "13.5px", color: "#2b2b2b", fontWeight: 500 }}>{r.partyName}</TableCell>
                                                <TableCell align="left" sx={{ fontSize: "13.5px", color: "#2b2b2b", fontWeight: 500 }}>{r.zoneCodeDesc}</TableCell>
                                                <TableCell align="center" sx={{ fontSize: "13.5px", color: "#222", fontWeight: 600 }}>{formatQty(r.total_mtr)}</TableCell>
                                                <TableCell align="center" sx={{ fontSize: "13.5px", color: "#222", fontWeight: 600 }}>{formatIndianShort(r.total_amount)}</TableCell>
                                            </TableRow>
                                        ))}

                                        {/* ✅ GRAND TOTAL ROW */}
                                        <TableRow sx={{ background: "#efefef" }}>
                                            <TableCell
                                                colSpan={2}
                                                align="center"
                                                sx={{ fontWeight: 700 }}
                                            >
                                                GRAND TOTAL
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontWeight: 700 }}>
                                                {formatQty(customerTotals.qty)}
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontWeight: 700 }}>
                                                {formatIndianShort(customerTotals.amt)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={4} sx={{ p: 0 }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",   // ✅ move to right
                                                        alignItems: "center",
                                                        pr: 2
                                                    }}
                                                >
                                                    <TablePagination
                                                        component="div"
                                                        rowsPerPageOptions={[customerPagination.limit]}
                                                        count={customerPagination.totalRecords || 0}
                                                        rowsPerPage={customerPagination.limit || 10}
                                                        page={(customerPage || 1) - 1}
                                                        onPageChange={handleCustomerPageChange}
                                                    />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>


                                </Table>
                                </TableContainer>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <Typography
                                sx={{
                                    mb: 1,
                                    px: 0,
                                    fontSize: { xs: "0.95rem", md: "1rem" },
                                    fontWeight: 700,
                                    color: "#ffffff",
                                    textAlign: "left"
                                }}
                            >
                                Current Month Sales Customer Report
                            </Typography>
                            <Paper elevation={3} sx={{ overflow: "hidden" }}>
                                <TableContainer
                                    sx={{
                                        maxHeight: { xs: "none", md: "70vh" },
                                        overflowY: "auto",
                                        overflowX: "auto"
                                    }}
                                >
                                    <Table stickyHeader sx={{ minWidth: 760 }}>
                                        <TableHead>
                                            <TableRow>
                                                {["ZONE", "NAME", "DIVISION", "QTY (mtr)", "AMT"].map(h => (
                                                    <TableCell
                                                        key={h}
                                                        align={["ZONE", "NAME", "DIVISION"].includes(h) ? "left" : "center"}
                                                        sx={{
                                                            background: "red",
                                                            color: "#fff",
                                                            fontSize: "14px",
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {salesRows.length ? (
                                                salesRows.map((r, i) => (
                                                    <TableRow
                                                        key={i}
                                                        sx={{
                                                            backgroundColor: i % 2 === 0 ? "#fafafa" : "#ffffff",
                                                            "&:hover": { backgroundColor: "#fff3f3" }
                                                        }}
                                                    >
                                                        <TableCell align="left" sx={{ fontSize: "13.5px", color: "#2b2b2b", fontWeight: 500 }}>{r.zoneCodeDesc}</TableCell>
                                                        <TableCell align="left" sx={{ fontSize: "13.5px", color: "#2b2b2b", fontWeight: 500 }}>{r.partyName}</TableCell>
                                                        <TableCell align="left" sx={{ fontSize: "13.5px", color: "#2b2b2b", fontWeight: 500 }}>{r.division}</TableCell>
                                                        <TableCell align="center" sx={{ fontSize: "13.5px", color: "#222", fontWeight: 600 }}>{formatQty(r.qty)}</TableCell>
                                                        <TableCell align="center" sx={{ fontSize: "13.5px", color: "#222", fontWeight: 600 }}>{formatIndianShort(r.netAmount)}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center">
                                                        No Records Found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        {salesRows.length > 0 && (
                                            <TableFooter>
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={3}
                                                        align="center"
                                                        sx={{
                                                            position: "sticky",
                                                            bottom: 0,
                                                            background: "#efefef",
                                                            fontWeight: 700,
                                                            fontSize: "14px",
                                                            color: "#111827",
                                                            zIndex: 2,
                                                            borderTop: "1px solid #d1d5db"
                                                        }}
                                                    >
                                                        GRAND TOTAL
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            position: "sticky",
                                                            bottom: 0,
                                                            background: "#efefef",
                                                            fontWeight: 700,
                                                            fontSize: "14px",
                                                            color: "#111827",
                                                            zIndex: 2,
                                                            borderTop: "1px solid #d1d5db"
                                                        }}
                                                    >
                                                        {formatQty(mainTotals.qty)}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            position: "sticky",
                                                            bottom: 0,
                                                            background: "#efefef",
                                                            fontWeight: 700,
                                                            fontSize: "14px",
                                                            color: "#111827",
                                                            zIndex: 2,
                                                            borderTop: "1px solid #d1d5db"
                                                        }}
                                                    >
                                                        {formatIndianShort(mainTotals.amt)}
                                                    </TableCell>
                                                </TableRow>
                                            </TableFooter>
                                        )}
                                    </Table>
                                </TableContainer>

                                <Box sx={{ backgroundColor: "#fff", borderTop: "1px solid #ddd", px: { xs: 1, md: 2 }, overflowX: "auto" }}>
                                    <TablePagination
                                        component="div"
                                        rowsPerPageOptions={[100]}
                                        count={totalRecords}
                                        rowsPerPage={100}
                                        page={page - 1}
                                        onPageChange={handleChangePage}
                                    />
                                </Box>
                            </Paper>
                        </Grid>

                    </Grid>

                </div>
            </ZoomWrapper>
        </>
    );
};

export default CurrentMonthsSalesReport;
